import { SectionTitleUnderlined, UIButton } from "common/components";
import { useDispatch, useMemoisedSelector, useSelector } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { pushModalScreen } from "domains/modal/actions";
import { ModalHeader } from "domains/modal/components/ModalHeader";
import { FilterTags } from "domains/monitor/filter/components/FilterTags";
import { getTopicsFilterSelectedIds } from "domains/monitor/filter/selectors";
import { createTopicsSelector, getFollowedTopicsIds } from "entities/topics/selectors";

export const MonitorFilterModal = () => {
  const dispatch = useDispatch();
  const items = useMemoisedSelector(getFollowedTopicsIds, createTopicsSelector);
  const selectedItems = useSelector(getTopicsFilterSelectedIds);
  const translate = useTranslate();

  const manageTopicHandle = () => dispatch(pushModalScreen({ id: "ManageTopics" }));

  return (
    <>
      <ModalHeader title={translate("app.filter.title")} />
      <SectionTitleUnderlined>{translate("app.monitor.following_topics")}</SectionTitleUnderlined>
      <FilterTags items={items} selectedItems={selectedItems} />
      <UIButton onClick={manageTopicHandle} style={{ marginTop: "2rem" }} variant="filled">
        {translate("app.discover.manage_topics")}
      </UIButton>
    </>
  );
};
